import { c as _c } from "react/compiler-runtime";
import { Checkbox, Form } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import Section from '@/playbook-builder/components/section';
import SubSection from '@/playbook-builder/components/sub-section';
import type { IdentityDataNodeProps } from '@/playbook-builder/playbook-builder.types';
import type { FormIdentityData } from '../../collect-data-node/components/person/person.types';
import { collectsData } from '../utils/data-collection-utils';
type InformationFormProps = {
  node: IdentityDataNodeProps;
};
const InformationForm = t0 => {
  const $ = _c(23);
  const {
    node
  } = t0;
  const collects = collectsData(node.data);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "collectData.person.personal"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("playbook-builder", t1);
  let t2;
  if ($[1] !== t) {
    t2 = t(_temp);
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t) {
    t3 = t(_temp2);
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t) {
    t4 = t(_temp3);
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t) {
    t5 = t(_temp4);
    $[7] = t;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t) {
    t6 = t(_temp5);
    $[9] = t;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t6) {
    t7 = <Form.Checkbox name="email" label={t6} />;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t) {
    t8 = t(_temp6);
    $[13] = t;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t8) {
    t9 = <Form.Checkbox name="phoneNumber" label={t8} />;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  const T0 = Checkbox;
  let t10;
  if ($[17] !== t) {
    t10 = t(_temp7);
    $[17] = t;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  const t11 = collects("full_address");
  let t12;
  if ($[19] !== T0 || $[20] !== t10 || $[21] !== t11) {
    t12 = <T0 label={t10} checked={t11} disabled={true} />;
    $[19] = T0;
    $[20] = t10;
    $[21] = t11;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  return <Section title={t2}><SubSection title={t3}><Checkbox label={t4} checked={collects("name")} disabled={true} /><Checkbox label={t5} checked={collects("dob")} disabled={true} />{t7}{t9}{t12}</SubSection></Section>;
};
export default InformationForm;
function _temp($) {
  return $.title;
}
function _temp2($_0) {
  return $_0.basic.title;
}
function _temp3($_1) {
  return $_1.basic.name;
}
function _temp4($_2) {
  return $_2.basic.dob;
}
function _temp5($_3) {
  return $_3.basic.email;
}
function _temp6($_4) {
  return $_4.basic.phone;
}
function _temp7($_5) {
  return $_5.basic.address;
}